import React, { useState } from "react";

export default function StartPage({clientName , setIspaly ,setIsInfoModalOpen }) {


  function setWelcomePage(){
    setIspaly(true);
    if (localStorage.getItem('isReload') == 'done') {
      if (!localStorage.getItem('inModel')) {
        setIsInfoModalOpen(true);
        localStorage.setItem('inModel', 'done')
      }
    }
  }
  return (
    <div class="startup_page_main" id="#model1">
      <div class="welcome">
        <img style={{ height: "80px" }} src="/wave.png" />
        <div class="welcome-text">Welcome!</div>
      </div>
      <div class="welcome-heading">
        <div class="welcome-heading-text">
         <p> You have 6 tries to guess a word connected to news from</p>
          </div>
        <div class="customer-name">
          <p>{clientName}.</p>

          </div>
      </div>
      <div class="spacer"></div>
      <div class="play-button">
        <button onClick={setWelcomePage} class="btn btn-dark play-btn" id="showModel2">
          Play
        </button>
      </div>
    </div>
  );
}
